import { TextButton } from 'seagull';
import { AddCircleLiner24 } from 'seagull/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateNewButton(_ref) {
  let {
    intent,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(TextButton, {
    underline: "none",
    weight: "normal",
    intent: intent,
    prefixIcon: /*#__PURE__*/_jsx(AddCircleLiner24, {}),
    onClick: onClick,
    children: "Create new"
  });
}